<template>
  <svg 
    id="bar-chart-horizontal" 
    viewBox="-1, -1, 401, 111" 
    :style="{width: width, height: height}"
    preserveAspectRatio="xMidYMid meet"
  >
    <rect class="background" top="-1" left="-1" width="402" height="112" />
    <line class="axis" x1=100 x2=100 y1=0 y2=110 />
    <line class="axis" x1=200 x2=200 y1=0 y2=110 />
    <line class="axis" x1=300 x2=300 y1=0 y2=110 />
    <text class="axis-label" x=102 y=106 alignment-baseline="middle" >25%</text>
    <text class="axis-label" x=202 y=106 alignment-baseline="middle" >50%</text>
    <text class="axis-label" x=302 y=106 alignment-baseline="middle" >75%</text>
    <rect ref="blueBar" class="blue bar" x=0 y=0 height=25 />
    <rect ref="greenBar" class="green bar" x=0 y=25 height=25 />
    <rect ref="redBar" class="red bar" x=0 y=50 height=25 />
    <rect ref="yellowBar" class="yellow bar" x=0 y=75 height=25 />
    <text ref="blueLabel" class="bar-label" y=12.5 alignment-baseline="middle" />
    <text ref="greenLabel" class="bar-label" y=37.5 alignment-baseline="middle" />
    <text ref="redLabel" class="bar-label" y=62.5 alignment-baseline="middle" />
    <text ref="yellowLabel" class="bar-label" y=87.5 alignment-baseline="middle" />
    <linearGradient id="blueBarGradient" gradientTransform="rotate(90)">
      <stop offset="5%" stop-color="#E0F7FA" />
      <stop offset="50%" stop-color="#40c4ff" />
      <stop offset="95%" stop-color="#0091ea" />
    </linearGradient>
    <linearGradient id="greenBarGradient" gradientTransform="rotate(90)">
      <stop offset="5%" stop-color="#F9FBE7" />
      <stop offset="50%" stop-color="#00c853" />
      <stop offset="95%" stop-color="#1b5e20" />
    </linearGradient>
    <linearGradient id="redBarGradient" gradientTransform="rotate(90)">
      <stop offset="5%" stop-color="#FBE9E7" />
      <stop offset="50%" stop-color="#ff5252" />
      <stop offset="95%" stop-color="#d50000" />
    </linearGradient>
    <linearGradient id="yellowBarGradient" gradientTransform="rotate(90)">
      <stop offset="5%" stop-color="#FFFDE7" />
      <stop offset="50%" stop-color="#ffeb3b" />
      <stop offset="95%" stop-color="#F9A825" />
    </linearGradient>
  </svg>
</template>

<script>
import * as d3 from "d3";

export default {
  name: "BarChart",
  props: {
    value: Object,
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "auto"
    }
  },
  computed: {
    blueWidth() {
      return this.getWidth(this.value.blue);
    },
    greenWidth() {
      return this.getWidth(this.value.green);
    },
    redWidth() {
      return this.getWidth(this.value.red);
    },
    yellowWidth() {
      return this.getWidth(this.value.yellow);
    }
  },
  watch: {
    value: {
      deep: true,
      handler: function() {
        d3.select(this.$refs.blueBar)
          .transition()
          .duration(250)
          .attr("width", this.getWidth(this.value.blue));
        d3.select(this.$refs.greenBar)
          .transition()
          .duration(250)
          .attr("width", this.getWidth(this.value.green));
        d3.select(this.$refs.redBar)
          .transition()
          .duration(250)
          .attr("width", this.getWidth(this.value.red));
        d3.select(this.$refs.yellowBar)
          .transition()
          .duration(250)
          .attr("width", this.getWidth(this.value.yellow));

        d3.select(this.$refs.blueLabel)
          .transition()
          .duration(250)
          .attr("x", this.blueWidth + 2)
          .text(`${this.value.blue} (${Math.round(this.value.blue / 0.3)}%)`);
        d3.select(this.$refs.greenLabel)
          .transition()
          .duration(250)
          .attr("x", this.greenWidth + 2)
          .text(`${this.value.green} (${Math.round(this.value.green / 0.3)}%)`);
        d3.select(this.$refs.redLabel)
          .transition()
          .duration(250)
          .attr("x", this.redWidth + 2)
          .text(`${this.value.red} (${Math.round(this.value.red / 0.3)}%)`);
        d3.select(this.$refs.yellowLabel)
          .transition()
          .duration(250)
          .attr("x", this.yellowWidth + 2)
          .text(
            `${this.value.yellow} (${Math.round(this.value.yellow / 0.3)}%)`
          );
      }
    }
  },
  methods: {
    getWidth: val => {
      return (val / 30) * 400;
    }
  },
  mounted() {
    d3.select(this.$refs.blueLabel)
      .attr("x", this.blueWidth + 2)
      .text(`${this.value.blue} (${Math.round(this.value.blue / 0.3)}%)`);
    d3.select(this.$refs.greenLabel)
      .attr("x", this.greenWidth + 2)
      .text(`${this.value.green} (${Math.round(this.value.green / 0.3)}%)`);
    d3.select(this.$refs.redLabel)
      .attr("x", this.redWidth + 2)
      .text(`${this.value.red} (${Math.round(this.value.red / 0.3)}%)`);
    d3.select(this.$refs.yellowLabel)
      .attr("x", this.yellowWidth + 2)
      .text(`${this.value.yellow} (${Math.round(this.value.yellow / 0.3)}%)`);
  }
};
</script>

<style scoped>
svg {
  width: 100%;
  height: auto;
}
rect.background {
  fill: #efefef;
}
.axis {
  stroke: #ddd;
}
.axis-label {
  text-anchor: start;
  font-size: 8px;
  fill: #aaa;
}
.blue.bar {
  fill: url("#blueBarGradient");
}
.green.bar {
  fill: url("#greenBarGradient");
}
.red.bar {
  fill: url("#redBarGradient");
}
.yellow.bar {
  fill: url("#yellowBarGradient");
}
.bar {
  stroke: black;
}
.bar-label {
  fill: black;
  font-size: 8px;
}
</style>
